import { ROOT_CATEGORY_ID } from "../../../normalizers/constants";

export function handleUserQuantityDefinitionCategoryCreated(state, payload) {
  const { category } = payload;
  // console.log('new cat is: ', category)
  
  if (!category?.id) return state;

  const categoryId = category.id;

  if (state.categoriesById[categoryId]) {
    // console.log('Category already exists in state');
    // console.log('Current categoriesById:', state.categoriesById);
    // console.log('Current categoryIds:', state.categoryIds);
    return state;
  }

  const isRoot = category.id == null;

  const newCategory = {
    id: isRoot ? ROOT_CATEGORY_ID : category.id,
    nodeId: isRoot ? ROOT_CATEGORY_ID : `c${category.id}`,
    code: category.code ?? null,
    title: category.title ?? "Uncategorized",
    type: "category",
    isActive: category.is_active ?? false,
    orderNumber: category.order_number ?? 9999,
    quantities: [],
  };
  
  // console.log('newCategory: ', newCategory);
  // console.log('BEFORE UPDATE - categoriesById:', state.categoriesById);
  // console.log('BEFORE UPDATE - categoryIds:', state.categoryIds);

  const newState = {
    ...state,
    categoriesById: {
      ...state.categoriesById,
      [newCategory.id]: newCategory,
    },
    categoryIds: [
      ...state.categoryIds,
      newCategory.id,
    ],
  };

  // console.log('AFTER UPDATE - categoriesById:', newState.categoriesById);
  // console.log('AFTER UPDATE - categoryIds:', newState.categoryIds);
  // console.log('Was category added?', !!newState.categoriesById[newCategory.id]);
  
  return newState;
}